module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/aiCreation/components/AiVideoTopBar/asset/white-text.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/aiCreation/components/AiVideoTopBar/asset/white-text.png
// module id = 1718
// module chunks = 367